export default __webpack_public_path__ + "static/media/maid-group.e7a1fc14.jpg";